// @core/api/endpoints/chat/reply_in_thread.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MessageResponse,
  ReplyInThreadRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Reply in thread
 * Sends a reply to an existing message, creating or continuing a threaded discussion. Thread participants receive notifications.
 */
export async function ReplyInThread(
  conversation_id: string,
  message_id: string,
  data: ReplyInThreadRequest,
  options?: RequestOptions
): Promise<MessageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id/thread`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.post<MessageResponse>(requestPath, data, requestOptions);
}
